export const LANGUAGE_KEY = 'lang';
export type CookieLanguageValue = 'no' | 'en';

export const readCookieValue = (key: string): string | undefined => {
  var nameEQ = key + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) == 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return undefined;
};

export const getCookieKeyValues = (): Map<string, string> => {
  const results = new Map<string, string>();
  const cookie = document.cookie;
  if (!cookie) {
    return results;
  }
  const keyValueArr = cookie.split(';');
  for (let i = 0; i < keyValueArr.length; i++) {
    const keyValueString = keyValueArr[i];
    const arr = keyValueString.split('=');
    const key = arr[0].trim(); // remove whitespaces
    const value = arr[1];
    results.set(key, value);
  }
  return results;
};

export const upsertCookie = (key: string, value: string, domain: string) => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 2);
  const expires = date.toUTCString();
  let keyValueString = `${key}=${value}; expires=${expires}; path=/; SameSite=Lax`;
  if (domain) {
    keyValueString += `; domain=${domain}`;
  }
  console.log(keyValueString);
  document.cookie = keyValueString;
};

export const getCookieLanguage = (): CookieLanguageValue | undefined => {
  return readCookieValue(LANGUAGE_KEY) as CookieLanguageValue | undefined;
};

export const setCookieLanguage = (val: CookieLanguageValue, domain: string): void => {
  return upsertCookie(LANGUAGE_KEY, val, domain);
};
